import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router";
import Layout from "../../Layout";
import menu from "./menu";
import {
  PermissionContext,
  Roles,
  withPermission,
} from "../../../util/PermissionProvider";
import MemberRegistrationPage from "../../cineclub/MemberRegistrationPage";

export default function WalkInSection(props) {
  const { match } = props;
  const { userPermissions } = useContext(PermissionContext);
  return (
    userPermissions && (
      <Layout menuObj={menu} hideDrawer>
        <Switch>
          <Route
            exact
            path={`${match.url}/registration`}
            component={withPermission(MemberRegistrationPage, [
              Roles.SUPERADMIN,
              Roles.CINECLUB_WI_EDITOR,
            ])}
          />
          <Redirect to={`${match.url}/registration`} />
        </Switch>
      </Layout>
    )
  );
}
